exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-box.style5>i[data-v-c3593598]{background:#9f4378}.icon-box.style5[data-v-c3593598]{background:#f5f5f5}.alert.alert-help[data-v-c3593598]{background:#dcecf6;color:#406f8c}.alert .close[data-v-c3593598],.info-box .close[data-v-c3593598]{color:#406f8c}.icon-check-srvcs[data-v-c3593598]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check-srvcs[data-v-c3593598]:after{content:\"\";position:absolute;top:0;right:0;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #3b79b0}.errormsg[data-v-c3593598]{margin-bottom:3px;margin-top:3px;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c3593598","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/forms/BookingnoTab.vue
// module id = 393
// module chunks = 0